import React from 'react';

import { Title } from 'shared';

import { FirstStep } from 'features/get-started/components/FirstStep';
import { useTranslation } from 'hooks/useTranslation';

export const FirstStepPage = () => {
  const { t } = useTranslation('get-started');

  return (
    <>
      <Title title={t('createYourFirstReward')} />
      <FirstStep />
    </>
  );
};
